import React from "react";
import { NavLink } from "react-router-dom";
// Fonction d'image
import ReturnImage from "../functions/image";

const Realisations = () => {
    return (
        <div className="realisations container" id="realisations">
            <div className="row text-white">
                <div className="realisations-column col-12 col-lg-6 pt-4 pb-4 pt-sm-5 pb-sm-5 px-4 px-sm-5 py-4 py-sm-5">
                    <h2 className="realisations-title text-center">Réalisations étudiantes</h2>
                    <NavLink className="realisations-button btn btn-primary btn-icon" to="/etudiant">
                        Etudiant
                        <svg viewBox="0 0 40 38" xmlns="http://www.w3.org/2000/svg">
                            <path d="M39 19.8889L21.9388 37L1 16L1 2L21.9388 23L30.4694 14.4444L39 5.88889" />
                        </svg>
                    </NavLink>
                </div>
                <svg className="realisations-form one" viewBox="0 0 90 560" fill="none" preserveAspectRatio="xMinYMid meet" xmlns="http://www.w3.org/2000/svg">
                    <rect fill="#1E1E1E"/>
                    <path d="M40.8805 271.555C70.2247 326.229 28.6537 486.633 4.2002 560H90.0002V0C61.4002 67.737 11.5363 216.88 40.8805 271.555Z" fill="#C23636"/>
                </svg>
                <svg className="realisations-form two" width="150" height="710" viewBox="0 0 150 710" fill="none" reserveAspectRatio="xMinYMid meet" xmlns="http://www.w3.org/2000/svg">
                    <rect width="150" height="710" fill="#1E1E1E"/>
                    <path d="M68.1338 344.292C117.041 413.612 47.7559 616.981 7 710H150V0C102.333 85.8809 19.2268 274.973 68.1338 344.292Z" fill="#C23636"/>
                </svg>

                <div className="realisations-column col-12 col-lg-6 pt-4 pb-4 pt-sm-5 pb-sm-5 py-4 py-sm-5 py-4 py-sm-5">
                    <h2 className="realisations-title text-center">Réalisations pro</h2>
                    <NavLink className="realisations-button btn btn-primary btn-icon" to="/pro">
                        Professionnel
                        <svg viewBox="0 0 40 38" xmlns="http://www.w3.org/2000/svg">
                            <path d="M39 19.8889L21.9388 37L1 16L1 2L21.9388 23L30.4694 14.4444L39 5.88889" />
                        </svg>
                    </NavLink>
                </div>
            </div>
            <ReturnImage
             imageName="mustafa-suisse"
             classname="realisations-image"
             alt="La liste des réalisations de Mustafa Ekiz"
             viewport={100} />
        </div>
    )
};

export default Realisations;